const SmallBanner = function ({ children, className }) {
  return (
    <div className={"text-xs rounded bg-black bg-opacity-5 text-center py-2 px-1 w-full " + className}>
      {children}
    </div>
  );
};

export default SmallBanner;
